import Base from './Base';

export default class UploadAll extends Base {
  getProgress = (progress) => progress;

  delay = () => Promise.resolve({});
}
